import { Plus, Trash } from "@phosphor-icons/react";
import { Section } from "./Section";

export default function EducationSection({ resume, setResume, open, onToggle }) {
  const add = () =>
    setResume((r) => ({
      ...r,
      education: [...r.education, { id: crypto.randomUUID(), school: "", degree: "", field: "", startDate: "", endDate: "", details: "" }],
    }));
  const update = (i, k, v) =>
    setResume((r) => {
      const next = [...r.education];
      next[i] = { ...next[i], [k]: v };
      return { ...r, education: next };
    });
  const remove = (i) =>
    setResume((r) => ({ ...r, education: r.education.filter((_, idx) => idx !== i) }));

  return (
    <Section id="education" title="Education" open={open} onToggle={onToggle}>
      <div className="space-y-4">
        {resume.education.map((edu, i) => (
          <div key={edu.id} className="border border-black/10 p-4 space-y-3" data-testid={`education-item-${i}`}>
            <div className="flex items-center justify-between">
              <div className="label-mono">Entry {i + 1}</div>
              {resume.education.length > 1 && (
                <button onClick={() => remove(i)} className="text-neutral-400 hover:text-[#FF2A00]" data-testid={`remove-education-${i}`}>
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input className="field-input" placeholder="School" value={edu.school} onChange={(e) => update(i, "school", e.target.value)} data-testid={`edu-school-${i}`} />
              <input className="field-input" placeholder="Degree (BS, MA...)" value={edu.degree} onChange={(e) => update(i, "degree", e.target.value)} data-testid={`edu-degree-${i}`} />
              <input className="field-input" placeholder="Field of study" value={edu.field} onChange={(e) => update(i, "field", e.target.value)} data-testid={`edu-field-${i}`} />
              <div className="grid grid-cols-2 gap-2">
                <input className="field-input" placeholder="Start" value={edu.startDate} onChange={(e) => update(i, "startDate", e.target.value)} data-testid={`edu-start-${i}`} />
                <input className="field-input" placeholder="End" value={edu.endDate} onChange={(e) => update(i, "endDate", e.target.value)} data-testid={`edu-end-${i}`} />
              </div>
              <textarea className="field-textarea col-span-2 min-h-[52px]" placeholder="Honors, GPA, notes (optional)" value={edu.details} onChange={(e) => update(i, "details", e.target.value)} data-testid={`edu-details-${i}`} />
            </div>
          </div>
        ))}
        <button onClick={add} className="btn-secondary text-xs px-4 py-2" data-testid="add-education-button">
          <Plus size={14} weight="bold" /> Add education
        </button>
      </div>
    </Section>
  );
}
